// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as OrderFareTable from "./OrderFareTable.bs.js";
import * as Navbar$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as OrderPricingTable from "./OrderPricingTable.bs.js";

function OrderFareDashboard$OrderFareNavbar(Props) {
  var order_crn = Props.order_crn;
  return React.createElement(Navbar$Catalyst.make, {
              title: "Order Fare Details",
              navbar_item_first: {
                label: "Order",
                value: {
                  TAG: /* Text */0,
                  _0: order_crn
                }
              }
            });
}

var OrderFareNavbar = {
  make: OrderFareDashboard$OrderFareNavbar
};

function OrderFareDashboard(Props) {
  var order_crn = Props.order_crn;
  var order_fare = Props.order_fare;
  var order_details = Props.order_details;
  return React.createElement("div", {
              className: "c-order-fare-dashboard"
            }, React.createElement(OrderFareDashboard$OrderFareNavbar, {
                  order_crn: order_crn
                }), React.createElement("div", {
                  className: "order-fare-table"
                }, React.createElement("div", {
                      className: "title"
                    }, "Order Fares"), React.createElement(OrderFareTable.make, {
                      order_fare: order_fare,
                      order_details: order_details
                    })), React.createElement(OrderPricingTable.make, {
                  order_fare: order_fare
                }));
}

var make = OrderFareDashboard;

export {
  OrderFareNavbar ,
  make ,
  
}
/* react Not a pure module */
